/* eslint-disable sonarjs/cognitive-complexity */
import React, { createContext } from 'react';

import * as Sebrae from '@sebrae/react-core';
import { useInterviewController } from '../../../../../hooks/controllers/interview-controller';
import { useModuleController } from '../../../../../hooks/controllers/module-public-controller';
import { useQuizProfileController } from '../../../../../hooks/controllers/quiz-profile-controller';
import { useModule } from '../../../../../hooks/module/module';

export const QuizProfileContext = createContext();

export const QuizProfileProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = React.useState(1);
  const [previusStep, setPreviusStep] = React.useState(0);
  const [questionsSelected, setQuestionsSelected] = React.useState({});
  const [moduleSettings, setModuleSettings] = React.useState({});
  const [user, setUser] = React.useState('');
  const [userId, setUserId] = React.useState('');
  const [save, setSave] = React.useState(false);

  const { getRouteParam } = Sebrae.useRouter();
  const { searchModuleForParams } = useModule();
  const { findInterviewByIdPublic, findInterviewByUserAuth } =
    useInterviewController();
  const { getSettingsModule } = useModuleController();
  const { getProfileStepByIdInterview } = useQuizProfileController();

  React.useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     const result = await findInterviewByIdPublic(+interviewId);
    //     const module = await getSettingsModule(result?.moduleId);
    //     if (module) {
    //       setModuleSettings(module.settingsMap);
    //     }
    //     // setName(result.candidate.name);
    //   } catch (error) {
    //     console.error('Erro ao buscar dados:', error);
    //   }
    // };

    const fetchUserLoged = async () => {
      try {
        const user = await findInterviewByUserAuth();
        const module = await getSettingsModule(+user?.module.id);
        setUserId(user.id);
        if (module) {
          setModuleSettings(module.settingsMap);
        }
        setUser(user);
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    fetchUserLoged();
  }, [
    searchModuleForParams,
    getProfileStepByIdInterview,
    getRouteParam,
    findInterviewByIdPublic,
    getSettingsModule,
    findInterviewByUserAuth,
  ]);

  const handleChangeStep = React.useCallback((value) => {
    setCurrentStep(value);
  }, []);

  const handleChangeQuestionSelected = React.useCallback((value) => {
    setQuestionsSelected(value);
  }, []);

  return (
    <QuizProfileContext.Provider
      value={{
        currentStep,
        handleChangeStep,
        questionsSelected,
        handleChangeQuestionSelected,
        user,
        moduleSettings,
        save,
        setSave,
        previusStep,
        setPreviusStep,
        userId,
      }}
    >
      {children}
    </QuizProfileContext.Provider>
  );
};
